export default __webpack_public_path__ + "static/media/requeriments-svgrepo-com.0945c5c3.svg";